export * from './HeadingText';
export { default as HeadingText } from './HeadingText';
